import React from "react";
import "./stylesheets/Work.css";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import GitHubIcon from "@mui/icons-material/GitHub";

const WorkCard = ({ ele }) => {
  const { image, title, description, tech, vid, netlify, github } = ele;

  return (
    <div className="workcard" data-aos="zoom-in">
      <img src={image} alt="" />
      <br />
      <h3>{title}</h3>
      <br />
      <p>{description}</p>
      <br />
      <p>
        <span style={{ color: "#dc143c", fontWeight: "600" }}>
          Teck Stack :{" "}
        </span>
        {tech}
      </p>
      <div>
        <a href={vid} target="blank">
          <div>
            <OndemandVideoIcon />
          </div>
        </a>
        <a href={netlify} target="blank">
          <div>
            <RemoveRedEyeIcon />
          </div>
        </a>
        <a href={github} target="blank">
          <div>
            <GitHubIcon />
          </div>
        </a>
      </div>
    </div>
  );
};

export default WorkCard;
